// Phase G3 Stage 1b: /play/reading — reading practice session.
// T1.3 Phase D: skill-parameterized via ?skill=<ms.read.*> (like
// /play/foundation). Defaults to ReadingSession's launch_safe CVC slice
// skill when no param, so existing no-param links keep working.
// MA-1004 (R1): the same validated `seed` and `resume` as /play/session
// (sessionDeepLink.ts), used by ReadingSession only when no checkpoint exists.
import { createFileRoute } from "@tanstack/react-router";
import { ReadingSession } from "@/screens/ReadingSession";
import { KidRouteError } from "@/components/RouterErrorFallback";
import { parseResumeParam, parseSeedParam } from "@/lib/engine/sessionDeepLink";

export const Route = createFileRoute("/play/reading")({
  errorComponent: KidRouteError, // MA-107
  validateSearch: (search: Record<string, unknown>): { skill?: string; resume?: number; seed?: string } => ({
    skill: typeof search.skill === "string" && search.skill.length > 0 ? search.skill : undefined,
    resume: parseResumeParam(search.resume),
    seed: parseSeedParam(search.seed),
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { skill, resume, seed } = Route.useSearch();
  return <ReadingSession skillId={skill} resumeAt={resume} seed={seed} />;
}
